<div
  style="
    height: 30px;
    padding: 4px;
    background: #126e51;
    color: #eeeeee;
    border: 0;
  "
  class="modal-header"
>
  <h4 style="color: #fdcf13; font-size: 17px; margin: 5px">Result</h4>
  <button
    style="background: #ff000000"
    type="button"
    class="btn close text-light"
    aria-label="Close"
    (click)="activeModal.dismiss('Cross click')"
  >
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body p-2">
  <div class="mb-2">
    Cricket -> {{ betdata.ledger.event_name }} ->
    {{ betdata.ledger.subtype | uppercase }}
  </div>
  <div class="d-flex flex-column mb-3">
    <div>
      Winner:
      {{
        betdata.ledger.subtype == "match_odd" ||
        betdata.ledger.subtype == "bookmaker"
          ? runner_name
          : winner
      }}
    </div>
    <div>
      Game Time:
      {{ betdata.ledger.game_time | date : "d/M/y H:mm:ss" }} (UTC+05:30)
    </div>
  </div>
  <div class="d-flex justify-content-between">
    <div>
      <span>
        <input
          type="radio"
          name="filter_type"
          value="all"
          id="filter_all"
          (input)="filterBetsByType($event)"
          checked
        />
        <label for="filter_all">All</label>
      </span>
      <span>
        <input
          type="radio"
          name="filter_type"
          value="Back"
          id="filter_back"
          (input)="filterBetsByType($event)"
        />
        <label for="filter_back">Back</label>
      </span>
      <span>
        <input
          type="radio"
          name="filter_type"
          value="Lay"
          id="filter_lay"
          (input)="filterBetsByType($event)"
        />
        <label for="filter_lay">Lay</label>
      </span>
      <span>
        <input
          type="radio"
          name="filter_type"
          value="deleted"
          id="filter_deleted"
          (input)="filterBetsByType($event)"
        />
        <label for="filter_deleted">Deleted</label>
      </span>
    </div>
    <div>
      Total bets: <span style="color: #39ff39">{{ totalbets }}</span> &nbsp;
      Total Win:
      <span
        [class.text-success]="totalwins >= 0"
        [class.text-danger]="totalwins < 0"
        >{{ totalwins }}</span
      >
    </div>
  </div>
  <div class="table table-hover table-responsive table-striped table-green">
    <table class="table table-sm">
      <thead>
        <tr style="border: none" class="bg-cyan">
          <th>Nation</th>
          <th>Rate</th>
          <th>Bhav</th>
          <th>Amount</th>
          <th>Win</th>
          <th>Date</th>
        </tr>
      </thead>
      <tbody *ngIf="filter_bets.length > 0; else noItems">
        <tr
          *ngFor="let bet of filter_bets"
          [class.lay-border]="bet.type == 'Lay'"
          [class.back-border]="bet.type == 'Back'"
          class="text-center"
        >
          <td>
            <input type="checkbox" class="checkbox" />{{ bet.runner_name }}
          </td>
          <td>{{ bet.main_type == "session" ? bet.price : "-" }}</td>
          <td>{{ bet.main_type == "session" ? bet.size : bet.price }}</td>
          <td>{{ bet.bet_amount }}</td>
          <td
            [class.text-success]="bet.profit_loss >= 0"
            [class.text-danger]="bet.profit_loss < 0"
          >
            {{ bet.profit_loss }}
          </td>
          <td>{{ bet.created_at | date : "d/M/y h:mm:ss a" }}</td>
        </tr>
      </tbody>
      <ng-template #noItems>
        <tbody>
          <tr>
            <td colspan="2">No records found</td>
          </tr>
        </tbody>
      </ng-template>
    </table>
  </div>
</div>
